import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="pursuits";

export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}


export function selectAll(parameter){
  // console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectStatistic(parameter){
  // console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectStatistic`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectOne(dealId){
  return axios({
    url: `/ws/${moduleName}/${dealId}`,
    method:'get',
  })
}


export function selectHsitoryDelAndNee(customerId,pursuitsId){
  return axios({
    url: `/ws/${moduleName}/selectHsitoryDelAndNee/${customerId}/${pursuitsId}`,
    method:'get',
  })
}


export function deletePursuits(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function updatePursuitsDetails(parameter){
  return axios({
    url: `/ws/${moduleName}/updatePursuitsDetails`,
    method: 'put',
    data:parameter
  })
}
export function changePursuitsStatus(parameter){
  return axios({
    url: `/ws/${moduleName}/changePursuitsStatus`,
    method: 'put',
    data:parameter
  })
}
export function queryYearTotalNum(){
  console.log("queryYearTotalNum")
  return axios({
    url: `/ws/${moduleName}/queryYearTotalNum`,
    method: 'get',
  })
}

// export function updateCurrentLease(parameter){
//   return axios({
//     url: `/ws/${moduleName}/updateCurrentLease`,
//     method: 'put',
//     data:parameter
//   })
// }


export function transferTransaction(parameter){
  return axios({
    url: `/ws/${moduleName}/transferTransaction`,
    method: 'post',
    data:parameter
  })
}

export function pursuitsToDeal(pursuitsId,parameter){
  return axios({
    url: `/ws/${moduleName}/pursuitsToDeal/${pursuitsId}`,
    method: 'get',
    data:parameter
  })
}

export function saveOldLease(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/saveOldLease`,
    method: 'post',
    data:parameter
  })
}

export default {
  insert,
  selectAll,
  selectOne,
  updatePursuitsDetails,
  queryYearTotalNum,
  // updateCurrentLease,
  transferTransaction,
  selectStatistic,
  deletePursuits,
  saveOldLease,
  pursuitsToDeal,
  selectHsitoryDelAndNee,
  changePursuitsStatus,
}